
export interface LocalStorageOneItem {
  [key:string]: string
}

export interface LocalStorageState {
  localStorage: LocalStorageOneItem | {}
}

export const initialState: LocalStorageState = {
  localStorage: {},
}
